import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { KonfigFehlt } from './components/system/KonfigFehlt'
import { fehlendeKonfig } from './utils/apiConfig'
import './index.css'
import './i18n'

// ── Die Konfiguration wird geprüft, BEVOR die App gebaut wird ─────────────────────────────────
//
// Grund ist ein Vorfall vom 2026-09-02: fehlten die zwei Supabase-Werte, warf `createClient` beim
// ersten Zugriff, der Wurf lief durch React durch, und was ankam war eine WEISSE SEITE. Für den,
// der davorsitzt, sieht das aus wie ein kaputtes Programm; tatsächlich fehlten zwei Zeilen in
// einer Compose-Datei.
//
// ⚠️ Die Prüfung steht hier und nicht in einer Fehlergrenze innerhalb der App, und das ist
// Absicht: eine Fehlergrenze fängt den Wurf erst, wenn er passiert — also irgendwo mitten im
// Aufbau, mit einer Meldung, die vom Zufall abhängt, welche Komponente zuerst den Client anfasst.
// Hier ist die Aussage eindeutig, und sie kommt vor allem anderen.
//
// ⛔ Der Wurf darf NICHT einfach verschluckt werden (etwa mit einem `try`, das weiterrendert):
// dann liefe das CMS ohne Anmeldung weiter und schlüge erst irgendwo tief drinnen fehl. Eine
// fehlende Umgebungsvariable soll SICHTBAR sein, nicht überlebt werden.
// Gehalten von `src/__tests__/konfigMeldung.test.tsx`.
const fehlend = fehlendeKonfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {fehlend.length > 0 ? <KonfigFehlt fehlend={fehlend} /> : <App />}
  </React.StrictMode>,
)
